export const getSwiperStyles = ({ isSmallScreen }: { isSmallScreen: boolean }) => ({
	...(isSmallScreen && { paddingBottom: '2rem' }),
});
